export enum SessionStorageKey {
  onboardingChannelCreateStarting = 'onboarding_channel_create_starting',
  onboardingScenarioCreateStarting = 'onboarding_scenario_create_starting'
}
